import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import Button from "components/CustomButtons/Button.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// sections of this Page
import SectionHeaders from "./Sections/SectionHeaders.js";
import SectionBlogs from "./Sections/SectionBlogs.js";
import SectionCards from "./Sections/SectionCardPays.js";
import Footer from "components/Footer/Footer.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";
import presentationStyle from "assets/jss/material-kit-pro-react/views/presentationStyle.js";
import descriptionStyle from "assets/jss/material-kit-pro-react/views/presentationSections/descriptionStyle.js";
import sizeCharts from "assets/img/sizecharts.jpg";
import egcolor from "assets/img/egcolor.jpg";
import SectionPricing from "./Sections/SectionPricing.js";
const useStyles = makeStyles(presentationStyle);
const useStylesDes = makeStyles(descriptionStyle);

export default function Home() {
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };
  const smoothScroll = (target) => {
    var targetScroll = document.getElementById(target);

    var targetOffTop = null;
    switch (target) {
      case "header":
        targetOffTop = targetScroll.offsetTop;
        break;
      case "promotion":
        targetOffTop = targetScroll.offsetTop + 300;
        break;
      case "shop":
        targetOffTop = targetScroll.offsetTop + 500;
        break;
      case "about":
        targetOffTop = targetScroll.offsetTop + 600;
        break;
      case "contact":
        targetOffTop = targetScroll.offsetTop;
        break;
      default:
        targetOffTop = targetScroll.offsetTop;
    }

    scrollGo(document.documentElement, targetOffTop, 1250);
  };
  const scrollGo = (element, to, duration) => {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function () {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };
  const classes = useStyles();
  const classesDes = useStylesDes();

  return (
    <>
      <SectionHeaders id="header" />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <GridContainer justify="center" spacing={6}>
          <GridItem sm={8}>
            <div id="promotion" style={{ marginLeft: 20, marginRight: 20 }}>
              <h3 className={classesDes.description}>
                <span
                  style={{
                    fontSize: "36px",
                    color: "#3C4858",
                    fontFamily: "Kanit",
                    fontWeight: "bold",
                  }}
                >
                  ด่วนสั่งซื้อตั้งแต่100ตัวขึ้นไป จัดส่งฟรีทั่วประเทศ!!
                </span>
              </h3>
              <p className={classesDes.description}>
                <span
                  style={{
                    fontSize: "18px",
                    color: "#3C4858",
                    fontFamily: "Kanit",
                    fontWeight: "bold",
                  }}
                >
                  ขายปลีก-ส่งเสื้อยืดสีพื้น และเสื้อสกรีน สินค้าผลิตจากในไทย
                  มีพร้อมจัดส่งทันที การันตีรับประกันสินค้าคุณภาพ
                </span>
              </p>
            </div>
          </GridItem>
          <GridItem sm={2}>
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <a href="https://page.line.me/mercurytshirt.com?openQrModal=true">
                <Button
                  variant="contained"
                  color="rose"
                  component="span"
                  style={{ fontSize: 18, width: 100 }}
                >
                  <i
                    className="fas fa-comment-dots"
                    style={{ marginRight: 10 }}
                  />
                  ติดต่อ
                </Button>
              </a>
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <NavPills
              color="rose"
              alignCenter
              tabs={[
                {
                  tabButton: "ตารางราคา",
                  tabContent: (
                    <img
                      alt="ตารางราคาเสื้อยืดคอกลมคอวี"
                      src={sizeCharts}
                      style={{ maxWidth: "100%" }}
                    />
                  ),
                },
                {
                  tabButton: "ชาร์ตสี",
                  tabContent: (
                    <img
                      alt="ชาร์ตสีเสื้อยืด"
                      src={egcolor}
                      style={{ maxWidth: "100%" }}
                    />
                  ),
                },
              ]}
            />
            <div className={classes.tabSpace} />
          </GridItem>
        </GridContainer>
        <div style={{ marginTop: 60 }} id="shop">
          <SectionCards />
        </div>
        <div id="about">
          <SectionBlogs />
        </div>
      </div>
      <div id="contact">
        <SectionPricing />
      </div>

      <Footer
        className="cusFooter"
        theme="white"
        content={
          <div>
            <div className={classes.left}>
              <a href="/" className={classes.footerBrand}>
                <label className="cusFooter title">© 2021 MercuryTshirt</label>
              </a>
            </div>
            <div className={classes.pullCenter}>
              <List className={classes.list}>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="#header"
                    data-number="1"
                    onClick={(e) => {
                      var isMobile = navigator.userAgent.match(
                        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
                      );
                      if (isMobile) {
                        // if we are on mobile device the scroll into view will be managed by the browser
                        e.preventDefault();
                        smoothScroll("header");
                      } else {
                        e.preventDefault();
                        smoothScroll("header");
                      }
                    }}
                    className={classes.block}
                  >
                    <label className="cusFooter">Home</label>
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="#promotion"
                    onClick={(e) => {
                      var isMobile = navigator.userAgent.match(
                        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
                      );
                      if (isMobile) {
                        // if we are on mobile device the scroll into view will be managed by the browser
                        e.preventDefault();
                        smoothScroll("header");
                      } else {
                        e.preventDefault();
                        smoothScroll("promotion");
                      }
                    }}
                    className={classes.block}
                  >
                    <label className="cusFooter">Promotion</label>
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="#shop"
                    onClick={(e) => {
                      var isMobile = navigator.userAgent.match(
                        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
                      );
                      if (isMobile) {
                        // if we are on mobile device the scroll into view will be managed by the browser
                        e.preventDefault();
                        smoothScroll("header");
                      } else {
                        e.preventDefault();
                        smoothScroll("shop");
                      }
                    }}
                    className={classes.block}
                  >
                    <label className="cusFooter">Shop now</label>
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="#about"
                    onClick={(e) => {
                      var isMobile = navigator.userAgent.match(
                        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
                      );
                      if (isMobile) {
                        // if we are on mobile device the scroll into view will be managed by the browser
                        e.preventDefault();
                        smoothScroll("header");
                      } else {
                        e.preventDefault();
                        smoothScroll("about");
                      }
                    }}
                    className={classes.block}
                  >
                    <label className="cusFooter">About us</label>
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href="#contact"
                    onClick={(e) => {
                      var isMobile = navigator.userAgent.match(
                        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
                      );
                      if (isMobile) {
                        // if we are on mobile device the scroll into view will be managed by the browser
                        e.preventDefault();
                        smoothScroll("header");
                      } else {
                        e.preventDefault();
                        smoothScroll("contact");
                      }
                    }}
                    className={classes.block}
                  >
                    <label className="cusFooter">Contact us</label>
                  </a>
                </ListItem>
              </List>
            </div>
            <div className={classes.rightLinks}>
              <ul>
                <li>
                  <Button
                    href="https://web.facebook.com/mercurytshirt?_rdc=1&_rdr"
                    style={{ color: "#00c402" }}
                    justIcon
                    simple
                  >
                    <i className="fab fa-line" />
                  </Button>
                </li>
                <li>
                  <Button
                    href="https://page.line.me/mercurytshirt.com?openQrModal=true"
                    color="facebook"
                    justIcon
                    simple
                  >
                    <i className="fab fa-facebook" />
                  </Button>
                </li>
                <li>
                  <Button
                    href="https://www.youtube.com/channel/UCqvgj54z4tEvKf0Rd5GZcmQ"
                    color="youtube"
                    justIcon
                    simple
                  >
                    <i className="fab fa-youtube" />
                  </Button>
                </li>
              </ul>
            </div>
          </div>
        }
      />
    </>
  );
}
